import Auth from '@aws-amplify/auth'
import { consoleError } from 'shared/helpers/consoleError'

export const requestInterceptor = async (config: any) => {
  return new Promise((resolve, _reject) => {
    const getJWT = async () => {
      let jwt: string | 0 = 0
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true })
      if (Boolean(user)) {
        const currentSession = await Auth?.currentSession()
        const accessToken = currentSession?.getIdToken()
        jwt = accessToken?.getJwtToken()
      }
      return jwt
    }
    getJWT()
      .then((token: string | 0) => {
        if (config.headers) {
          config.headers.Authorization = token
        }
        resolve(config)
      })
      .catch(error => {
        consoleError(error)
        resolve(config)
      })
  })
}

export const responseInterceptor = (result: any) => result.data.data
